import Circle from "./app/Circle";

export const gameWidth = 500;
export const gameHeight = 900;

export const powerUpMeterPosition = {
  x: gameWidth - 50,
  y: 60,
};

export interface ColorTheme {
  name: string;
  backgroundColor: number;
  circleColors: number[];
  lineColor: number;
  uiBackground: string;
  uiTextColor: string;
  buttonBackground: string;
  buttonBorderColor: string;
}

export const colorThemes: ColorTheme[] = [
  {
    name: "Classic",
    backgroundColor: 0x352d34,
    circleColors: [0xfe4a49, 0xfed766, 0x009fb7, 0xccff66, 0x5d2e8c, 0x00a878],
    lineColor: 0xcccccc,
    uiBackground: "#352d34ff",
    uiTextColor: "#e5e5e5ff",
    buttonBackground: "#3c0836ff",
    buttonBorderColor: "#cccccc",
  },
  {
    name: "Neon",
    backgroundColor: 0x0d0d0d,
    circleColors: [0xff00ff, 0x00ffff, 0x39ff14, 0xffff00, 0xff3131, 0x7b68ee],
    lineColor: 0x333333,
    uiBackground: "#0d0d0d",
    uiTextColor: "#dfffffff",
    buttonBackground: "#7b68ee",
    buttonBorderColor: "#500950ff",
  },
];

let currentThemeIndex = 0;

export const getCurrentTheme = (): ColorTheme => colorThemes[currentThemeIndex];

export const setTheme = (index: number) => {
  currentThemeIndex = index;
};

export const backgroundColor = () => getCurrentTheme().backgroundColor;

export const circleColors = () => getCurrentTheme().circleColors;
export const circleAlpha = 0.7;
export const randomCircleColor = () => {
  const colors = circleColors();
  return colors[Math.floor(Math.random() * colors.length)];
};
export const randomPlayerColor = (
  currentCircles: Circle[],
  circlesCreated: number,
) => {
  // every 3 circles, give a color that exists
  if (currentCircles.length > 0 && circlesCreated % 3 === 0) {
    return currentCircles.map((c) => c.color)[
      Math.floor(Math.random() * currentCircles.length)
    ];
  }
  // totally random
  return randomCircleColor();
};

export const baseObstacleSpeed = 3.25;
export const obstacleSpeedModifier = 13;

export const playerSpeed = 12;

export const lineColor = () => getCurrentTheme().lineColor;
export const lineHeight = 3;
export const circleRadius = 42;
export const topLimit = 165;

export type Difficulty = "easy" | "hard";
export const easyColorCount = 5;
export const easyObstacleRadius = Math.round(circleRadius * 0.8);
export const height = 450;
export const bottomLimit = gameHeight - circleRadius * 4;
export const startingYPosition =
  bottomLimit + (gameHeight - bottomLimit) / 1.55;
export const randomYPos = () => topLimit + Math.random() * height;
export const randomFullYPos = () => Math.random() * gameHeight;
export const randomXPos = () => 100 + Math.random() * 300;
